export default async (path) => {
	return path.split(",")[1];
};